import { datadogRum } from '@datadog/browser-rum';

import { MParticleAdapter } from 'state/mParticle/mparticle-adapter';
import * as Braze from 'utils/braze';
import { getApiKey } from 'utils/environment';

export const MPARTICLE = 'mparticle';
export const BRAZE = 'braze';
export const BRANCH = 'branch';
export const LAUNCHDARKLY = 'launchdarkly';

export type ConsentGroups = {
  marketing: boolean;
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  stamp: string;
};

export type ConsentStatus = {
  name: string;
  enable: boolean;
};

export const EVENTS_TO_LISTEN = ['UC_UI_CMP_EVENT'];
export const addEventListener = (callback: VoidFunction) => {
  EVENTS_TO_LISTEN.forEach((event: string) =>
    window.addEventListener(event, () => {
      callback();
    })
  );
};

export const removeEventListeners = (callback: VoidFunction) => {
  EVENTS_TO_LISTEN.forEach((event: string) =>
    window.removeEventListener(event, () => {
      callback();
    })
  );
};

export const isBranchAvailable = (): boolean => {
  return Boolean(getApiKey(BRANCH));
};

export const handleMparticleConsent = (enable: boolean) => {
  if (enable) {
    MParticleAdapter.setOptOut(false);
  } else {
    MParticleAdapter.setOptOut(true);
  }
};

export const handleBranchConsent = (enable: boolean) => {
  if (isBranchAvailable()) {
    if (enable) {
      window.branch.disableTracking(false);
    } else {
      window.branch.disableTracking(true);
    }
  }
};

export const handleBrazeConsent = (enable: boolean) => {
  if (enable) {
    Braze.enableSDK();
  } else {
    Braze.disableSDK();
  }
};

export const handleDataDogConsent = (enable: boolean) => {
  if (enable) {
    datadogRum.startSessionReplayRecording();
  } else {
    datadogRum.stopSessionReplayRecording();
  }
};

type ConfigFunc = (enable: boolean) => void;

type HandlerConfigType = {
  braze: ConfigFunc;
  datadog: ConfigFunc;
  mParticle: ConfigFunc;
  branch: ConfigFunc;
};

const handlerConfig: HandlerConfigType = {
  braze: handleBrazeConsent,
  datadog: handleDataDogConsent,
  mParticle: handleMparticleConsent,
  branch: handleBranchConsent,
};

export const handleConsents = (consents: ConsentStatus[]) => {
  consents.forEach((consent: ConsentStatus) => {
    const configHandler = handlerConfig?.[consent.name as keyof HandlerConfigType];
    if (configHandler) {
      configHandler(consent.enable);
    }
  });
};
